import _ from 'lodash';
import $ from 'jquery';
import Widget from 'gears/ui/widget/component';

// Public Class Methods

class Button extends Widget {

  _initialize() {
    if (this.$target) {
      this.$el = this.$target;
      return this._render();
    } else {
      this._render();
      return this.$target = this.$el.data(this._getNamespace(), this);
    }
  }

  _update() {
    return this._render();
  }

  _render() {
    if (!this.$el) {
      switch (this.options.tag) {
        case "a":
          this.$el = $(`<a href=\"#\" class=\"${Button.className}\">${this.options.title}</a>`);
          break;
        case "input":
          this.$el = $(`<input class=\"${Button.className}\" type=\"button\" value=\"${this.options.title}\" />`);
          break;
        default: // "a"
          this.$el = $(`<button class=\"${Button.className}\" type=\"button\">${this.options.title}</button>`);
      }

      if (this.options.type) { this.$el.addClass(`${Button.className}--` + this.options.type); }
      let self = this;
      if (this.options.onClick) {
        return this.$el.on(`click.${this._getNamespace()}`, function(e) {
          e.preventDefault();
          return self.options.onClick.apply(self.$el);
        });
      }
    } else {
      if (this.changedOptions.title) {
        if (this.$el[0].nodeName === "INPUT") {
          this.$el.attr("value", this.options.title);
        } else {
          this.$el.html(this.options.title);
        }
      }
      if (this.changedOptions.type) {
        if (this.previousOptions.type) { this.$el.removeClass(`${Button.className}--` + this.previousOptions.type); }
        this.$el.addClass(`${Button.className}--` + this.options.type);
      }
      if (this.changedOptions.onClick) {
        this.$el.off(`click.${this._getNamespace()}`);
        return this.$el.on(`click.${this._getNamespace()}`, this.options.onClick);
      }
    }
  }
}

Button.defaults = {
  // title: (required)
  // type: (optional)
  // onClick: (optional)
};

Button.className = "button";

Button.namespace = "gears:button";

export default Button;
